/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { ReportAbuseReceiptionTypeTitles } from "../../ReportAbuseUIHelpers";

export const ReportedByNameColumnFormatter = (cellContent, row, rowIndex) => {
  const { reportedby } = row;
  const { firstname = "", lastname = "" } = reportedby || {};
  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {`${firstname} ${lastname}`}
        {firstname.length === 0 && lastname.length === 0 && "-"}
      </div>
      <> </>
    </>
  );
};
